var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{attrs:{"id":_vm.id},on:{"input":_vm.__twoWayDataBinding__}})}
var staticRenderFns = []

export { render, staticRenderFns }